import { CategoryImageText } from '@engbers/components/category-image-text';
export const EngbersCategoryImageTextTastic = ({
  data
}) => <CategoryImageText categoriesImageText={data.categoryImageText} data-sentry-element="CategoryImageText" data-sentry-component="EngbersCategoryImageTextTastic" data-sentry-source-file="index.tsx" />;